import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {},
		bgImage: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',

			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ opacity }) => opacity / 100,
			},
		},
		textWrap: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'stretch',
			width: '100%',

			[theme.breakpoints.up('md')]: {
				paddingLeft: theme.spacing(8),
				paddingTop: theme.spacing(6.5),
				paddingBottom: theme.spacing(9),
			},
		},
		subtitle: {
			position: 'relative',
			'&:before': {
				fontFamily: '"Font Awesome 5 Pro", serif',
				content: '"\\f30b"',
				fontSize: '3.125rem',
				position: 'absolute',
				top: '-1.1rem',
				left: '-4rem',
				color: theme.palette.primary.main,
				transition: theme.transitions.create(['color']),
				display: 'none',
				[theme.breakpoints.up('md')]: {
					display: 'block',
				},
			},
		},
		imageGrid: {
			display: 'flex',
			justifyContent: 'center',
		},

		desktopImage: {
			display: 'flex',
			height: '100%',
			width: '100%',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'contain',
		},

		imageWrapper: {
			width: '100%',

			[theme.breakpoints.down('sm')]: {
				width: 'auto',
				marginLeft: theme.spacing(-2),
				marginRight: theme.spacing(-2),
				transition: theme.transitions.create(['margin-top', 'margin-bottom']),

				marginTop: ({ mobileImagePosition }) => {
					if (!mobileImagePosition?.isRightAlignment) return null

					return theme.spacing(3)
				},
				marginBottom: ({ mobileImagePosition }) => {
					if (!mobileImagePosition?.isLeftAlignment) return null

					return theme.spacing(3)
				},
			},
		},

		mobileImage: {
			marginLeft: theme.spacing(-2),
			marginRight: theme.spacing(-2),

			'& picture': {
				display: 'flex',
				maxHeight: theme.spacing(40),
			},
			'& img': {
				objectFit: 'contain',
				objectPosition: 'center',
				width: '100%',
			},
		},
		wrapContainer: {},
		title: {
			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => mobileAlignment?.metaValue,
				},
			},
		},
		subtitleText: {
			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => mobileAlignment?.metaValue,
				},
			},
		},
		text: {
			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => mobileAlignment?.metaValue,
				},
			},
		},
		buttonContainer: {
			[theme.breakpoints.down('xs')]: {
				display: 'flex',
				justifyContent: ({ mobileAlignment }) => mobileAlignment?.contentAlignment() || null,
			},
		},
		action: {
			minWidth: theme.spacing(32.5),

			[theme.breakpoints.down('xs')]: {
				minWidth: 'auto',
				width: ({ mobileButtonWidth }) => (mobileButtonWidth?.isWide ? '100%' : 'auto'),
			},
		},
	}),
	{ name: 'Banners-Banner3' },
)

export default useStyles
